import {atom} from "recoil";

const docsAtom = atom({
    key: 'docs',
    default: {}
});

export default docsAtom;